import { render, staticRenderFns } from "./UserBirthday.vue?vue&type=template&id=08be6334&scoped=true"
import script from "./UserBirthday.vue?vue&type=script&lang=js"
export * from "./UserBirthday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be6334",
  null
  
)

export default component.exports